import Vue from 'vue'
import VueApollo from 'vue-apollo'
import 'cross-fetch/polyfill'
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client/src'
import Cookie from 'universal-cookie'
import { InMemoryCache } from 'apollo-cache-inmemory'

Vue.use(VueApollo)

export default (ctx, inject) => {
  const providerOptions = { clients: {} }
  const { app, beforeNuxtRender, req } = ctx
  const AUTH_TOKEN_NAME = 'apollo-token'
  const COOKIE_ATTRIBUTES = {"expires":7,"path":"\u002F","secure":false}
  const AUTH_TYPE = 'Bearer '
  const cookies = new Cookie(req && req.headers.cookie)

  // Config

      const shopifyenCHTokenName = ''  || AUTH_TOKEN_NAME

      function shopifyenCHGetAuth () {
        const token = cookies.get(shopifyenCHTokenName)
        return token && shopifyenCHClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let shopifyenCHClientConfig

        shopifyenCHClientConfig = {
  "httpEndpoint": "https://bellicon-ch.myshopify.com/api/2023-10/graphql.json",
  "httpLinkOptions": {
    "headers": {
      "X-Shopify-Storefront-Access-Token": "2c15d5f8d78ff89a00c3e411c2aa622c"
    }
  }
}

      const shopifyenCHValidateToken = () => true

      if (!shopifyenCHClientConfig.validateToken) {
        shopifyenCHClientConfig.validateToken = shopifyenCHValidateToken
      }

      const shopifyenCHCache = shopifyenCHClientConfig.cache
        ? shopifyenCHClientConfig.cache
        : new InMemoryCache(shopifyenCHClientConfig.inMemoryCacheOptions ? shopifyenCHClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        shopifyenCHCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.shopifyenCH : null)
      }

      if (!shopifyenCHClientConfig.getAuth) {
        shopifyenCHClientConfig.getAuth = shopifyenCHGetAuth
      }

      if (process.client && shopifyenCHClientConfig.browserHttpEndpoint) {
        shopifyenCHClientConfig.httpEndpoint = shopifyenCHClientConfig.browserHttpEndpoint
      }

      shopifyenCHClientConfig.ssr = !!process.server
      shopifyenCHClientConfig.cache = shopifyenCHCache
      shopifyenCHClientConfig.tokenName = shopifyenCHTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!shopifyenCHClientConfig.httpLinkOptions) {
          shopifyenCHClientConfig.httpLinkOptions = {}
        }
        if (!shopifyenCHClientConfig.httpLinkOptions.headers) {
          shopifyenCHClientConfig.httpLinkOptions.headers = {}
        }
        shopifyenCHClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let shopifyenCHApolloCreation = createApolloClient({
        ...shopifyenCHClientConfig
      })
      shopifyenCHApolloCreation.apolloClient.wsClient = shopifyenCHApolloCreation.wsClient

          providerOptions.clients.shopifyenCH = shopifyenCHApolloCreation.apolloClient

      const shopifydeCHTokenName = ''  || AUTH_TOKEN_NAME

      function shopifydeCHGetAuth () {
        const token = cookies.get(shopifydeCHTokenName)
        return token && shopifydeCHClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let shopifydeCHClientConfig

        shopifydeCHClientConfig = {
  "httpEndpoint": "https://bellicon-ch.myshopify.com/api/2023-10/graphql.json",
  "httpLinkOptions": {
    "headers": {
      "X-Shopify-Storefront-Access-Token": "2c15d5f8d78ff89a00c3e411c2aa622c"
    }
  }
}

      const shopifydeCHValidateToken = () => true

      if (!shopifydeCHClientConfig.validateToken) {
        shopifydeCHClientConfig.validateToken = shopifydeCHValidateToken
      }

      const shopifydeCHCache = shopifydeCHClientConfig.cache
        ? shopifydeCHClientConfig.cache
        : new InMemoryCache(shopifydeCHClientConfig.inMemoryCacheOptions ? shopifydeCHClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        shopifydeCHCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.shopifydeCH : null)
      }

      if (!shopifydeCHClientConfig.getAuth) {
        shopifydeCHClientConfig.getAuth = shopifydeCHGetAuth
      }

      if (process.client && shopifydeCHClientConfig.browserHttpEndpoint) {
        shopifydeCHClientConfig.httpEndpoint = shopifydeCHClientConfig.browserHttpEndpoint
      }

      shopifydeCHClientConfig.ssr = !!process.server
      shopifydeCHClientConfig.cache = shopifydeCHCache
      shopifydeCHClientConfig.tokenName = shopifydeCHTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!shopifydeCHClientConfig.httpLinkOptions) {
          shopifydeCHClientConfig.httpLinkOptions = {}
        }
        if (!shopifydeCHClientConfig.httpLinkOptions.headers) {
          shopifydeCHClientConfig.httpLinkOptions.headers = {}
        }
        shopifydeCHClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let shopifydeCHApolloCreation = createApolloClient({
        ...shopifydeCHClientConfig
      })
      shopifydeCHApolloCreation.apolloClient.wsClient = shopifydeCHApolloCreation.wsClient

          providerOptions.clients.shopifydeCH = shopifydeCHApolloCreation.apolloClient

      const shopifyfrCHTokenName = ''  || AUTH_TOKEN_NAME

      function shopifyfrCHGetAuth () {
        const token = cookies.get(shopifyfrCHTokenName)
        return token && shopifyfrCHClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let shopifyfrCHClientConfig

        shopifyfrCHClientConfig = {
  "httpEndpoint": "https://bellicon-ch.myshopify.com/api/2023-10/graphql.json",
  "httpLinkOptions": {
    "headers": {
      "X-Shopify-Storefront-Access-Token": "2c15d5f8d78ff89a00c3e411c2aa622c"
    }
  }
}

      const shopifyfrCHValidateToken = () => true

      if (!shopifyfrCHClientConfig.validateToken) {
        shopifyfrCHClientConfig.validateToken = shopifyfrCHValidateToken
      }

      const shopifyfrCHCache = shopifyfrCHClientConfig.cache
        ? shopifyfrCHClientConfig.cache
        : new InMemoryCache(shopifyfrCHClientConfig.inMemoryCacheOptions ? shopifyfrCHClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        shopifyfrCHCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.shopifyfrCH : null)
      }

      if (!shopifyfrCHClientConfig.getAuth) {
        shopifyfrCHClientConfig.getAuth = shopifyfrCHGetAuth
      }

      if (process.client && shopifyfrCHClientConfig.browserHttpEndpoint) {
        shopifyfrCHClientConfig.httpEndpoint = shopifyfrCHClientConfig.browserHttpEndpoint
      }

      shopifyfrCHClientConfig.ssr = !!process.server
      shopifyfrCHClientConfig.cache = shopifyfrCHCache
      shopifyfrCHClientConfig.tokenName = shopifyfrCHTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!shopifyfrCHClientConfig.httpLinkOptions) {
          shopifyfrCHClientConfig.httpLinkOptions = {}
        }
        if (!shopifyfrCHClientConfig.httpLinkOptions.headers) {
          shopifyfrCHClientConfig.httpLinkOptions.headers = {}
        }
        shopifyfrCHClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let shopifyfrCHApolloCreation = createApolloClient({
        ...shopifyfrCHClientConfig
      })
      shopifyfrCHApolloCreation.apolloClient.wsClient = shopifyfrCHApolloCreation.wsClient

          providerOptions.clients.shopifyfrCH = shopifyfrCHApolloCreation.apolloClient

      const shopifyenEUTokenName = ''  || AUTH_TOKEN_NAME

      function shopifyenEUGetAuth () {
        const token = cookies.get(shopifyenEUTokenName)
        return token && shopifyenEUClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let shopifyenEUClientConfig

        shopifyenEUClientConfig = {
  "httpEndpoint": "https://bellicon-eu.myshopify.com/api/2023-10/graphql.json",
  "httpLinkOptions": {
    "headers": {
      "X-Shopify-Storefront-Access-Token": "e14c288f4c9ef90c4df3e0b9ba2cfece"
    }
  }
}

      const shopifyenEUValidateToken = () => true

      if (!shopifyenEUClientConfig.validateToken) {
        shopifyenEUClientConfig.validateToken = shopifyenEUValidateToken
      }

      const shopifyenEUCache = shopifyenEUClientConfig.cache
        ? shopifyenEUClientConfig.cache
        : new InMemoryCache(shopifyenEUClientConfig.inMemoryCacheOptions ? shopifyenEUClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        shopifyenEUCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.shopifyenEU : null)
      }

      if (!shopifyenEUClientConfig.getAuth) {
        shopifyenEUClientConfig.getAuth = shopifyenEUGetAuth
      }

      if (process.client && shopifyenEUClientConfig.browserHttpEndpoint) {
        shopifyenEUClientConfig.httpEndpoint = shopifyenEUClientConfig.browserHttpEndpoint
      }

      shopifyenEUClientConfig.ssr = !!process.server
      shopifyenEUClientConfig.cache = shopifyenEUCache
      shopifyenEUClientConfig.tokenName = shopifyenEUTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!shopifyenEUClientConfig.httpLinkOptions) {
          shopifyenEUClientConfig.httpLinkOptions = {}
        }
        if (!shopifyenEUClientConfig.httpLinkOptions.headers) {
          shopifyenEUClientConfig.httpLinkOptions.headers = {}
        }
        shopifyenEUClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let shopifyenEUApolloCreation = createApolloClient({
        ...shopifyenEUClientConfig
      })
      shopifyenEUApolloCreation.apolloClient.wsClient = shopifyenEUApolloCreation.wsClient

          providerOptions.clients.shopifyenEU = shopifyenEUApolloCreation.apolloClient

      const shopifydeEUTokenName = ''  || AUTH_TOKEN_NAME

      function shopifydeEUGetAuth () {
        const token = cookies.get(shopifydeEUTokenName)
        return token && shopifydeEUClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let shopifydeEUClientConfig

        shopifydeEUClientConfig = {
  "httpEndpoint": "https://bellicon-eu.myshopify.com/api/2023-10/graphql.json",
  "httpLinkOptions": {
    "headers": {
      "X-Shopify-Storefront-Access-Token": "e14c288f4c9ef90c4df3e0b9ba2cfece"
    }
  }
}

      const shopifydeEUValidateToken = () => true

      if (!shopifydeEUClientConfig.validateToken) {
        shopifydeEUClientConfig.validateToken = shopifydeEUValidateToken
      }

      const shopifydeEUCache = shopifydeEUClientConfig.cache
        ? shopifydeEUClientConfig.cache
        : new InMemoryCache(shopifydeEUClientConfig.inMemoryCacheOptions ? shopifydeEUClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        shopifydeEUCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.shopifydeEU : null)
      }

      if (!shopifydeEUClientConfig.getAuth) {
        shopifydeEUClientConfig.getAuth = shopifydeEUGetAuth
      }

      if (process.client && shopifydeEUClientConfig.browserHttpEndpoint) {
        shopifydeEUClientConfig.httpEndpoint = shopifydeEUClientConfig.browserHttpEndpoint
      }

      shopifydeEUClientConfig.ssr = !!process.server
      shopifydeEUClientConfig.cache = shopifydeEUCache
      shopifydeEUClientConfig.tokenName = shopifydeEUTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!shopifydeEUClientConfig.httpLinkOptions) {
          shopifydeEUClientConfig.httpLinkOptions = {}
        }
        if (!shopifydeEUClientConfig.httpLinkOptions.headers) {
          shopifydeEUClientConfig.httpLinkOptions.headers = {}
        }
        shopifydeEUClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let shopifydeEUApolloCreation = createApolloClient({
        ...shopifydeEUClientConfig
      })
      shopifydeEUApolloCreation.apolloClient.wsClient = shopifydeEUApolloCreation.wsClient

          providerOptions.clients.shopifydeEU = shopifydeEUApolloCreation.apolloClient

      const shopifyfrEUTokenName = ''  || AUTH_TOKEN_NAME

      function shopifyfrEUGetAuth () {
        const token = cookies.get(shopifyfrEUTokenName)
        return token && shopifyfrEUClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let shopifyfrEUClientConfig

        shopifyfrEUClientConfig = {
  "httpEndpoint": "https://bellicon-eu.myshopify.com/api/2023-10/graphql.json",
  "httpLinkOptions": {
    "headers": {
      "X-Shopify-Storefront-Access-Token": "e14c288f4c9ef90c4df3e0b9ba2cfece"
    }
  }
}

      const shopifyfrEUValidateToken = () => true

      if (!shopifyfrEUClientConfig.validateToken) {
        shopifyfrEUClientConfig.validateToken = shopifyfrEUValidateToken
      }

      const shopifyfrEUCache = shopifyfrEUClientConfig.cache
        ? shopifyfrEUClientConfig.cache
        : new InMemoryCache(shopifyfrEUClientConfig.inMemoryCacheOptions ? shopifyfrEUClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        shopifyfrEUCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.shopifyfrEU : null)
      }

      if (!shopifyfrEUClientConfig.getAuth) {
        shopifyfrEUClientConfig.getAuth = shopifyfrEUGetAuth
      }

      if (process.client && shopifyfrEUClientConfig.browserHttpEndpoint) {
        shopifyfrEUClientConfig.httpEndpoint = shopifyfrEUClientConfig.browserHttpEndpoint
      }

      shopifyfrEUClientConfig.ssr = !!process.server
      shopifyfrEUClientConfig.cache = shopifyfrEUCache
      shopifyfrEUClientConfig.tokenName = shopifyfrEUTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!shopifyfrEUClientConfig.httpLinkOptions) {
          shopifyfrEUClientConfig.httpLinkOptions = {}
        }
        if (!shopifyfrEUClientConfig.httpLinkOptions.headers) {
          shopifyfrEUClientConfig.httpLinkOptions.headers = {}
        }
        shopifyfrEUClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let shopifyfrEUApolloCreation = createApolloClient({
        ...shopifyfrEUClientConfig
      })
      shopifyfrEUApolloCreation.apolloClient.wsClient = shopifyfrEUApolloCreation.wsClient

          providerOptions.clients.shopifyfrEU = shopifyfrEUApolloCreation.apolloClient

      const shopifynlEUTokenName = ''  || AUTH_TOKEN_NAME

      function shopifynlEUGetAuth () {
        const token = cookies.get(shopifynlEUTokenName)
        return token && shopifynlEUClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let shopifynlEUClientConfig

        shopifynlEUClientConfig = {
  "httpEndpoint": "https://bellicon-eu.myshopify.com/api/2023-10/graphql.json",
  "httpLinkOptions": {
    "headers": {
      "X-Shopify-Storefront-Access-Token": "e14c288f4c9ef90c4df3e0b9ba2cfece"
    }
  }
}

      const shopifynlEUValidateToken = () => true

      if (!shopifynlEUClientConfig.validateToken) {
        shopifynlEUClientConfig.validateToken = shopifynlEUValidateToken
      }

      const shopifynlEUCache = shopifynlEUClientConfig.cache
        ? shopifynlEUClientConfig.cache
        : new InMemoryCache(shopifynlEUClientConfig.inMemoryCacheOptions ? shopifynlEUClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        shopifynlEUCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.shopifynlEU : null)
      }

      if (!shopifynlEUClientConfig.getAuth) {
        shopifynlEUClientConfig.getAuth = shopifynlEUGetAuth
      }

      if (process.client && shopifynlEUClientConfig.browserHttpEndpoint) {
        shopifynlEUClientConfig.httpEndpoint = shopifynlEUClientConfig.browserHttpEndpoint
      }

      shopifynlEUClientConfig.ssr = !!process.server
      shopifynlEUClientConfig.cache = shopifynlEUCache
      shopifynlEUClientConfig.tokenName = shopifynlEUTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!shopifynlEUClientConfig.httpLinkOptions) {
          shopifynlEUClientConfig.httpLinkOptions = {}
        }
        if (!shopifynlEUClientConfig.httpLinkOptions.headers) {
          shopifynlEUClientConfig.httpLinkOptions.headers = {}
        }
        shopifynlEUClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let shopifynlEUApolloCreation = createApolloClient({
        ...shopifynlEUClientConfig
      })
      shopifynlEUApolloCreation.apolloClient.wsClient = shopifynlEUApolloCreation.wsClient

          providerOptions.clients.shopifynlEU = shopifynlEUApolloCreation.apolloClient

      const shopifyenUSTokenName = ''  || AUTH_TOKEN_NAME

      function shopifyenUSGetAuth () {
        const token = cookies.get(shopifyenUSTokenName)
        return token && shopifyenUSClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let shopifyenUSClientConfig

        shopifyenUSClientConfig = {
  "httpEndpoint": "https://bellicon-us.myshopify.com/api/2023-10/graphql.json",
  "httpLinkOptions": {
    "headers": {
      "X-Shopify-Storefront-Access-Token": "be0dc2704d43f765b1ad7d589f20d23d"
    }
  }
}

      const shopifyenUSValidateToken = () => true

      if (!shopifyenUSClientConfig.validateToken) {
        shopifyenUSClientConfig.validateToken = shopifyenUSValidateToken
      }

      const shopifyenUSCache = shopifyenUSClientConfig.cache
        ? shopifyenUSClientConfig.cache
        : new InMemoryCache(shopifyenUSClientConfig.inMemoryCacheOptions ? shopifyenUSClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        shopifyenUSCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.shopifyenUS : null)
      }

      if (!shopifyenUSClientConfig.getAuth) {
        shopifyenUSClientConfig.getAuth = shopifyenUSGetAuth
      }

      if (process.client && shopifyenUSClientConfig.browserHttpEndpoint) {
        shopifyenUSClientConfig.httpEndpoint = shopifyenUSClientConfig.browserHttpEndpoint
      }

      shopifyenUSClientConfig.ssr = !!process.server
      shopifyenUSClientConfig.cache = shopifyenUSCache
      shopifyenUSClientConfig.tokenName = shopifyenUSTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!shopifyenUSClientConfig.httpLinkOptions) {
          shopifyenUSClientConfig.httpLinkOptions = {}
        }
        if (!shopifyenUSClientConfig.httpLinkOptions.headers) {
          shopifyenUSClientConfig.httpLinkOptions.headers = {}
        }
        shopifyenUSClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let shopifyenUSApolloCreation = createApolloClient({
        ...shopifyenUSClientConfig
      })
      shopifyenUSApolloCreation.apolloClient.wsClient = shopifyenUSApolloCreation.wsClient

          providerOptions.clients.shopifyenUS = shopifyenUSApolloCreation.apolloClient

  const vueApolloOptions = Object.assign(providerOptions, {
      errorHandler (error) {
          console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
      }
  })

  const apolloProvider = new VueApollo(vueApolloOptions)
  // Allow access to the provider in the context
  app.apolloProvider = apolloProvider

  if (process.server) {
    const ApolloSSR = require('vue-apollo/ssr')
    beforeNuxtRender(({ nuxtState }) => {
      nuxtState.apollo = ApolloSSR.getStates(apolloProvider)
    })
  }

  inject('apolloHelpers', {
    onLogin: async (token, apolloClient = apolloProvider.defaultClient, cookieAttributes = COOKIE_ATTRIBUTES, skipResetStore = false) => {
      // Fallback for tokenExpires param
      if (typeof cookieAttributes === 'number') cookieAttributes = { expires: cookieAttributes }

      if (typeof cookieAttributes.expires === 'number') {
        cookieAttributes.expires = new Date(Date.now()+ 86400*1000*cookieAttributes.expires)
      }

      if (token) {
        cookies.set(AUTH_TOKEN_NAME, token, cookieAttributes)
      } else {
        cookies.remove(AUTH_TOKEN_NAME, cookieAttributes)
      }
      if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
      if (!skipResetStore) {
        try {
          await apolloClient.resetStore()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('%cError on cache reset (setToken)', 'color: orange;', e.message)
        }
      }
    },
    onLogout: async (apolloClient = apolloProvider.defaultClient, skipResetStore = false) => {
      cookies.remove(AUTH_TOKEN_NAME, COOKIE_ATTRIBUTES)
      if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
      if (!skipResetStore) {
        try {
          await apolloClient.resetStore()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
        }
      }
    },
    getToken: (tokenName = AUTH_TOKEN_NAME) => {
      return cookies.get(tokenName)
    }
  })
}
